import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import {
  Typo16Regular,
  Typo32Medium,
  Typo14Medium,
  Typo14Regular,
  Typo16Medium
} from "../UIComponents/Typography";
import GrayTextBox from "../../components/GrayTextBox";

import { t } from "../../utils/intl";
import infoLogo from "../../assets/i-circle-icn.svg";
import { getFormatCurrencyValue } from "../../helpers/customHooks/getFormatCurrencyValue";

interface RestTable {
  [key: string]: number;
}

interface Iprops {
  calculationResult: RestTable[];
}
export const StandardTable = ({ calculationResult }: Iprops) => {
  const [exampleValues, setExampleVales] = useState<number[]>([]);
  const formatNumber = (value: number) => {
    if (value === 0) {
      return value;
    }
    return new Intl.NumberFormat("pl-PL", { minimumFractionDigits: 2 }).format(Number(value));
  };

  useEffect(() => {
    if (calculationResult.length < 8) return;
    setExampleVales([
      calculationResult[7].value1,
      calculationResult[7].value2,
      calculationResult[7].value3
    ]);
  }, [calculationResult]);

  const getGuaranteedAmount = (data: number[]) => {
    return formatNumber(data[0] + 6 * data[1]);
  };

  return (
    <>
      <GrayTextBox>
        <ContentColumnWrapper>
          <Typo32Medium>{t("tableContentGrayTextBox.howReadTable")}</Typo32Medium>
          <Typo16Regular>
            {t("form.at")} <Typo16Medium>{t("form.guaranteedSurrenderValue")}</Typo16Medium>{" "}
            {t("form.consistsofTwoAmounts")}
          </Typo16Regular>
          <ListContainer>
            <ListElement>
              <ListElementNumber>
                <Typo16Regular>1)</Typo16Regular>
              </ListElementNumber>
              <ListElementText>
                <Typo16Regular>
                  <Typo16Medium>{t("table.baseRedemptionValueBasic")}</Typo16Medium> –{" "}
                  {t("table.baseRedemptionValueBasicDesc")}
                </Typo16Regular>
              </ListElementText>
            </ListElement>
            <ListElement>
              <ListElementNumber>
                <Typo16Regular>2)</Typo16Regular>
              </ListElementNumber>
              <ListElementText>
                <Typo16Regular>
                  <Typo16Medium> {t("table.amountIncreasingBaseValueBasic")}</Typo16Medium>{" "}
                  {t("table.amountIncreasingBaseValueDesc")}
                </Typo16Regular>
              </ListElementText>
            </ListElement>
          </ListContainer>
          <ExampleTitle>{t("form.example")}</ExampleTitle>
          <TextSection>
            <Typo16Regular>
              {t("response.StandardTableExamplesFirst", {
                base: getFormatCurrencyValue(exampleValues[0]),
                updatedBase: getFormatCurrencyValue(exampleValues[1])
              })}
            </Typo16Regular>
          </TextSection>
          <TextSection>
            <Typo16Regular>{t("response.StandardTableExamplesSecond")}</Typo16Regular>
            <br></br>
            <Typo16Regular>
              <br></br>
              {t("response.StandardTableExamplesSecondResult", {
                base: getFormatCurrencyValue(exampleValues[0]),
                updatedBase: getFormatCurrencyValue(exampleValues[1]),
                result: getGuaranteedAmount(exampleValues)
              })}
            </Typo16Regular>
          </TextSection>
          <TextSection>
            <Typo16Regular>{t("response.StandardTableExamplesThird")}</Typo16Regular>
          </TextSection>
          <TextSection>
            <Typo16Regular>{t("response.StandardTableExamplesFourth")}</Typo16Regular>
          </TextSection>
          <TextSection>
            <Typo16Regular>
              {t("response.StandardTableExamplesFifth", {
                percent: exampleValues[2]
              })}
            </Typo16Regular>
          </TextSection>
        </ContentColumnWrapper>
      </GrayTextBox>
      <GrayTextBox>
        <ContentRowWrapper>
          <Icon src={infoLogo} />
          <Typo16Regular>{t("tableContentStandardSmallGrayTextBox.Text")}</Typo16Regular>
        </ContentRowWrapper>
      </GrayTextBox>
      <TextContainer>
        <MainInfo>{t("tableContentStandardWhiteTextBox.TextFirst")}</MainInfo>
        <DefaultInfo>
          {t("tableContentStandardWhiteTextBox.TextSecond", { breakingLine: <br /> })}
        </DefaultInfo>
      </TextContainer>

      <TableContainer>
        <Wrapper>
          <TableHeaderMainRow>
            <TableHeaderCell style={{ width: "120px" }}>
              <Typo14Regular>{t("form.YearInsurance")}</Typo14Regular>
            </TableHeaderCell>
            <TableHeaderSmallContainer>
              <TableHeaderSmallInfo>
                <Typo14Medium>{t("form.guaranteedRedemption")}</Typo14Medium>
              </TableHeaderSmallInfo>
              <TableHeaderBiggerInfo>
                <TableHeaderSmallCell>
                  <Typo14Medium>{t("table.baseRedemptionValue")}</Typo14Medium>
                </TableHeaderSmallCell>
                <TableHeaderSmallCell>
                  <Typo14Medium> {t("table.AmountBaseRedemption")}</Typo14Medium>
                </TableHeaderSmallCell>
              </TableHeaderBiggerInfo>
            </TableHeaderSmallContainer>
            <TableHeaderCell>
              <Typo14Regular>{t("form.declaredAnnualAdvance")}</Typo14Regular>
            </TableHeaderCell>
          </TableHeaderMainRow>
          {calculationResult.map(el => {
            return (
              <TableHeaderRow key={el.year}>
                <TableCell style={{ width: "123px" }}>
                  <span>{el.year}</span>
                </TableCell>
                <TableCell>
                  <span>{formatNumber(el.value1)}</span>
                </TableCell>
                <TableCell>
                  <span>{formatNumber(el.value2)}</span>
                </TableCell>
                <TableCell>
                  <span>{el.value3 + ` %`}</span>
                </TableCell>
              </TableHeaderRow>
            );
          })}
        </Wrapper>
      </TableContainer>
    </>
  );
};

const ExampleTitle = styled.p`
  font-size: 24px;
  line-height: 28px;
  margin: 24px 0;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextSection = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ListElementText = styled.div``;
const ListElementNumber = styled.div`
  margin-right: 10px;
`;

const ListElement = styled.div`
  display: flex;
  &:first-child {
    margin-bottom: 24px;
  }
`;

const TextContainer = styled.div`
  margin: 20px 0 0;
  font-size: 18px;
  line-height: 25px;
  page-break-inside: avoid;
`;

const MainInfo = styled.p`
  font-style: normal;
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
`;

const DefaultInfo = styled.p`
  font-style: normal;
  margin: 2px 0 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`;

const TableContainer = styled.div`
  overflow-x: auto;
`;

const Wrapper = styled.div`
  min-width: 770px;
  margin-top: 64px;
  border: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
  page-break-inside: avoid;

  @media print {
    border: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-left: none;
    border-right: none;
  }
`;

const TableHeaderRow = styled.div`
  display: flex;
  width: 100%;
  page-break-inside: avoid;

  @media print {
    border-top: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
    border-bottom: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
    border-left: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
  }
`;

const TableHeaderMainRow = styled.div`
  display: flex;
  width: 100%;
  height: 134px;
  background-color: ${({ theme }) => theme.colors.lighterGray};

  @media print {
    border-left: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-bottom: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
  }
`;

const TableHeaderSmallContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 62.66%;
`;

const TableHeaderBiggerInfo = styled.div`
  display: flex;
`;

const TableHeaderSmallInfo = styled.div`
  height: 40px;
  background-color: ${({ theme }) => `solid 1px ${theme.colors.lighterGray} `};
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
  border-right: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};

  @media print {
    border-bottom: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
  }
`;

const TableHeaderSmallCell = styled.div`
  text-align: center;
  width: 50%;
  height: 95px;
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  line-height: 17px;
  padding: 6px 12px;
  background-color: ${({ theme }) => `solid 2px ${theme.colors.lighterGray} `};
  justify-content: center;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  border-right: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};

  @media print {
    border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    border-bottom: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
  }
`;

const TableHeaderCell = styled.div`
  text-align: center;
  width: 31.33%;
  height: 100%;
  font-size: 14px;

  &:first-child {
    text-align: left;
  }
  &:last-child {
    text-align: right;
    justify-content: end;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
  line-height: 17px;
  padding: 6px 12px;
  background-color: ${({ theme }) => `solid 2px ${theme.colors.lighterGray} `};
  justify-content: center;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media print {
    border-bottom: none;
  }

  &:not(:last-child) {
    border-right: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};

    @media print {
      border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    }
  }
`;

const TableCell = styled.div`
  text-align: center;
  width: 32%;
  padding: 18px 0;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  border-top: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};

  display: table;
  page-break-inside: auto;

  @media print {
    border-top: none;
  }

  &:first-child {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    padding-left: 12px;
  }

  &:last-child {
    text-align: right;
    padding-right: 12px;
  }

  &:not(:last-child) {
    border-right: ${({ theme }) => `solid 1px ${theme.colors.grayMedium} `};
    @media print {
      border-right: ${({ theme }) => `solid 2px ${theme.colors.grayMedium} `};
    }
  }
`;

const ContentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ContentColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: 24px;
  }

  span:last-child {
    margin-bottom: 0;
  }
`;

const Icon = styled.img`
  margin-right: 17px;
  filter: invert(58%) sepia(45%) saturate(10%) hue-rotate(68deg) brightness(95%) contrast(100%);
`;
